import React, { useEffect, useState } from 'react';
import { axiosInstance } from 'network/apis';
import { withAuthorization } from '../Session';
import { Container, Row, Spinner, Col } from 'react-bootstrap';
import CircularLoader from 'utils/loader/circular-loader';
import GCList from './gc-list';
import RestServices from '../services/RestServices.js';

import styles from './all-gc-list.module.scss';

function AllGCList(props) {
    const [GiftCards, setGiftCards] = useState(props.GiftCards);

    useEffect(() => {
        if (GiftCards == '') {
            getGiftCardsStatus();
        }
    }, [GiftCards, props.role]);

    const getGiftCardsStatus = () => {
        let dataRowBH = {
            UserRole: props.role,
            UniqeID: props.user.ProfileUniqeID
        };
        RestServices.getAssignedGiftCards(
            localStorage.getItem('FirebaseToken'),
            dataRowBH
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (
                    responseData.selectedGC &&
                    responseData.selectedGC.length > 0
                ) {
                    setGiftCards(responseData.selectedGC);
                } else {
                    setGiftCards('NONE');
                }
            });
    };

    if (!GiftCards) {
        return (
            <div className={styles.loader}>
                <CircularLoader />
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <p className={styles.header}>Gift Cards</p>
            <div className={styles.card}>
                <p className={styles.subHeader}>Top Brands</p>
                <GCList
                    GiftCards={GiftCards}
                    TopBrands="true"
                    isTopBrands={true}
                />
            </div>

            <div className={styles.card}>
                <p className={styles.subHeader}>Other Brands</p>
                <GCList GiftCards={GiftCards} TopBrands="false" />
            </div>
        </div>
    );
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(AllGCList);
